// MARK: React
import * as React from "react";

// MARK: Mobx
import { observer, inject } from "mobx-react";

// MARK: Router
import { Route, Switch } from "react-router-dom";

// MARK: Stores
import AuthStore from "../../../stores/AuthStore";

// MARK: Pages
import RequestsTable from "./RequestsTable";
import RequestDetails from "./RequestDetails";

interface IProps extends IStores {}
interface IStores {
	authStore: AuthStore;
}

@inject("authStore")
@observer
export default class Requests extends React.Component<IProps> {
	public static defaultProps: IStores;

	public render() {
		return (
			<Switch>
				<Route exact={true} path="/dashboard/requests/" component={RequestsTable} />
				<Route path="/dashboard/requests/:requestId" component={RequestDetails} />
			</Switch>
		);
	}
}
